import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  numCopies: {
    alignItems: 'center',
    backgroundColor: theme.appColors.hoverBackground,
    borderRadius: 3,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(0.5, 1),
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
  },
}));

interface NumCopiesProps {
  numCopies: number;
}

export function NumCopies({ numCopies }: NumCopiesProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.numCopies}>
      <Typography className={classes.text} color="primary">
        {numCopies === 1 ? `${numCopies} copy` : `${numCopies} copies`}
      </Typography>
    </div>
  );
}
